<template>
  <div class="flex items-center h-full">
    <vs-button
      color="danger"
      type="filled"
      icon-pack="feather"
      icon="icon-trash"
      @click="haldleDelete"
    ></vs-button>
  </div>
</template>
<script>
import { deleteClient } from '@/api/client'
// import { Delete_Leads } from '@/api/leads'
import { mapActions } from 'vuex'
export default {
  name: 'DeleteActions',
  mounted () {
    this.action = this.params.data.actionData
    // this.toggle = this.params.data.actionData.toggle
  },
  data () {
    return {
      action: {}
    }
  },
  methods: {
    ...mapActions([
      'SET_CLIENT_DELETE_ID',
      'SET_VIEW_CLIENT_SIDEBAR',
      'SET_VIEW_CLIENT_SIDEBAR_DATA',
      'SET_CLIENT_TOGGLE_DATA'
    ]),
    async haldleDelete () {
      const deleting_id = this.params.data.basic_details.client_users_id
      const payload = {
        client_user_id: [deleting_id]
      }
      
      if (!this.params.data.actionData.toggle) {
        if (this.params.data.basic_details.user_type === 'Parent' && this.params.data.children.length > 0) {
          const initial = this.params.data.children[0].child.active_user === '1'
          const ischildDeactive = this.checkAllChildDeactive(this.params.data.children, initial)
          if (!ischildDeactive) {
            try {
              const data = await deleteClient(payload, this.$store.getters.customerId)
              this.SET_CLIENT_DELETE_ID(deleting_id)
              
              this.$vs.notify({
                title: 'Client Deleted',
                text: 'Client Deleted Successfully',
                ...this.successProp()
              })
            } catch (error) {
              
            }
          } else {
            this.$vs.notify({
              title: 'Warning',
              text: 'Deactive all minor first',
              ...this.warnProp()
            })
          }
        } else {
          try {
            const data = await deleteClient(payload, this.$store.getters.customerId)
            this.SET_CLIENT_DELETE_ID(deleting_id)
            
            this.$vs.notify({
              title: 'Client Deleted',
              text: 'Client Deleted Successfully',
              ...this.successProp()
            })
          } catch (error) {
            
          }
        }


      } else {
        this.$vs.notify({
          title: 'Warning',
          text: 'Can’t remove an active student. Please deactivate the student first',
          ...this.warnProp()
        })
      }
      
    }
  }
}
</script>
